import { Map as ImmutableMap } from 'immutable';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'atom... Remove this comment to see the full error message
import { deref, unwatch, watch } from 'atom';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message
import { isResolved } from 'reference-resolvers/utils';
import { listOf } from 'react-immutable-proptypes';
import FilterOperatorType from 'customer-data-filters-ui/components/propTypes/FilterOperatorType';
import PropTypes from 'prop-types';
import PropertyOptionRecord from 'customer-data-objects/property/PropertyOptionRecord';
import { PureComponent } from 'react';
import get from 'transmute/get';
import Raven from 'raven-js';
import { jsx as _jsx } from "react/jsx-runtime";
function getFlattenedTeamMap(teams) {
  return teams.reduce((acc, team) => acc.merge({
    [team.get('id')]: team
  }).merge(getFlattenedTeamMap(team.get('childTeams'))), ImmutableMap());
}
export default class DisplayValueTeam extends PureComponent {
  constructor() {
    // @ts-expect-error ts-migrate(2554) FIXME: Expected 1-2 arguments, but got 0.
    super();
    this.handleReferenceChange = reference => {
      if (isResolved(reference)) {
        const {
          value
        } = this.props;
        reference = reference.map(team => team.get('referencedObject'));
        this.setState({
          reference: getFlattenedTeamMap(reference).get(String(value))
        });
      }
    };
    this.state = {
      reference: null
    };
    this.referenceAtom = null;
  }
  componentDidMount() {
    const {
      getFamilyValueResolver,
      operator
    } = this.props;
    const resolver = getFamilyValueResolver(operator);
    if (resolver && typeof resolver.all !== 'function') {
      Raven.captureException(new Error(`[Expected a reference resolver] resolver does not have 'all' function; operator.field: ${JSON.stringify(operator.field)}`));
    }
    if (resolver && resolver.all) {
      this.referenceAtom = resolver.all();
      watch(this.referenceAtom, this.handleReferenceChange);
      this.handleReferenceChange(deref(this.referenceAtom));
    }
  }
  componentWillUnmount() {
    if (this.referenceAtom) {
      unwatch(this.referenceAtom, this.handleReferenceChange);
    }
  }
  render() {
    const {
      value,
      specialOptions
    } = this.props;
    const {
      reference
    } = this.state;
    const matchingSpecialOption =
    // @ts-expect-error ts-migrate(7031) FIXME: Binding element 'v' implicitly has an 'any' type.
    specialOptions && specialOptions.find(({
      value: v
    }) => v === value) || {};
    const valueName = matchingSpecialOption.label || matchingSpecialOption.text || get('name', reference) || get('id', reference) || value;
    return /*#__PURE__*/_jsx("span", {
      children: valueName
    });
  }
}
DisplayValueTeam.propTypes = {
  getFamilyValueResolver: PropTypes.func.isRequired,
  operator: FilterOperatorType.isRequired,
  specialOptions: listOf(PropTypes.instanceOf(PropertyOptionRecord).isRequired),
  value: PropTypes.oneOfType([PropTypes.element, PropTypes.node, PropTypes.string]).isRequired
};